/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useMergeState } from '../../../irmlib/src/hooks'
import { setBusy, clearBusy, closeGeneralDialog, openGeneralDialog } from '../../../irmlib/src/containers'
import { useTheme } from 'irmlib/styles'
// import MuiDataTable from '../../Controls/MuiDataTable'
// import { Box } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
// import { getUser } from '../../../redux/global'
import { DateTime } from '../../../irmlib/src/components/FormControls'
import { today, getMonth } from '../../../irmlib/src/common'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions'
import * as routePaths from '../../../navigation/routePaths'
import { useTranslation } from 'react-i18next'
import { Dialog, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core'
import { LocalOrderModifyModal } from './LocalViewActivityOrderModify'
// import { MenuButton } from 'irmlib/components/Controls'
import { MoreVert } from 'irmlib/icons'
import { ContainedButton, OutlinedButton, MenuButton } from 'irmlib/components/Controls'
// import { closeGeneralDialog, openGeneralDialog } from 'irmlib/containers'
import { successToast } from '../../../common/functions'
import { MaterialReactTable } from 'material-react-table'
import { Box, Typography, CircularProgress } from '@mui/material'
import ExportCsv from '../../Controls/ExportCsv'
// import { uploadRefImg, getImgFromNats } from '../../../services/nats/localNatsTransactions'
// import { useNats } from '../../../providers/NatsProvider.jsx'
import { useGetNatsImage } from '../../../services/nats/useGetNatsImage'
import * as constants from '../../../irmlib/src/common/constants'
import { Visibility } from '@material-ui/icons'
// import { useParams, useLocation } from 'react-router-dom'


const BottomPaddedDiv = styled('div')`
  padding-bottom: 20px;
`

const TableContainer = styled(BottomPaddedDiv)`
`

const JobLink = styled(Link)`
  color: ${props => props.theme.palette.primary.main};
  text-decoration: none;
`
const initialState = {
  selectedData: [],
  showModalToModifyOrder: false,
  orderModifyRequesId: false,
}

const LocalViewActivityData = (props) => {
  const [, setState, getState] = useMergeState(initialState)
  const location = useLocation()
  const { selectedDatas } = location.state || {}
  const value = props.FilterData
  const theme = useTheme()
  const { t } = useTranslation()
  // const { natsService } = useNats()
  const { getImgFromNats } = useGetNatsImage()
  const [myJobdata, setData] = React.useState([])
  const [selectedRefImage, setSelectedRefImage] = React.useState(null)
  const [imageError, setImageError] = React.useState(false)
  const [requestData, setRequestData] = useState(false)
  const [loadingImage, setLoadingImage] = useState(false)
  
  // Image cache to store loaded NATS images
  // const imageCache = useRef(new Map())
  const isDialogOpenRef = useRef(false)
  const isMountedRef = useRef(true)

  // Track component mount status
  useEffect(() => {
    isMountedRef.current = true
    return () => {
      isMountedRef.current = false
    }
  }, [])

  useEffect(() => {
    if (!isMountedRef.current) return
    setRequestData(false)
    getPageData()
  }, [value, requestData])
  
  useEffect(() => {
    let unsubscribe = null
    
    // Wrap setRequestData to check mount status
    const safeSetRequestData = (data) => {
      if (isMountedRef.current) {
        setRequestData(data)
      }
    }
    
    const setupListener = async () => {
      if (!isMountedRef.current) return
      getPageData()
      unsubscribe = await localGdeTransactions.getGdeActivity('listener', value, selectedDatas, safeSetRequestData)
    }
    
    setupListener()
    
    return () => {
      if (unsubscribe) {
        unsubscribe()
      }
    }
  }, [value])

  useEffect(() => {
    if (!isMountedRef.current) return
    getPageData()
  }, [requestData])

  const dataRet = async (val) => {
    if (!isMountedRef.current) return []
    
    setBusy()
    let collection
    if (requestData) {
      collection = requestData
    } else {
      collection = await localGdeTransactions.getGdeActivity('normal', val, selectedDatas, false)
    }

    if (!isMountedRef.current) {
      clearBusy()
      return []
    }

    const activityList = []
    for (const doc of collection?.docs) {
      const docData = doc.data()
      let dateOfCreation = false
      if (docData.createdTS) {
        dateOfCreation = moment(docData.createdTS.seconds, 'X').format('YYYY-MM-DD')
      }

      if (dateOfCreation === 'Invalid date') {
        dateOfCreation = docData.createdTS.substring(0, 10)
      }

      let boxCount = docData.boxCount
      let error = false
      if ((boxCount === undefined || boxCount === 0) && docData?.apiResponse?.status?.error?.message !== '') {
        boxCount = docData?.apiResponse?.status?.error?.message
        error = true
      }
      
      // Remove NATS image loading - just store the reference
      // We'll load it on-demand when the icon is clicked
      activityList.push({
        activityId: doc.id,
        status: docData.status,
        customer: docData.accountLevel1.toUpperCase(),
        confidence: docData.confidence !== undefined ? docData.confidence : '-',
        assetType: docData.assetType,
        lob: docData.lob,
        customRequestName: docData.customRequestName,
        dateCreated: dateOfCreation,
        orderNumber: docData.orderId,
        imgReference: docData.imgReference, // Store original reference (could be NATS or URL)
        totalBoxes: boxCount,
        district: docData.district,
        remarks: docData.remarks,
        statusCount: docData.statusCount,
        boxCount: docData.boxCount,
        error: error
      })
    }
    
    if (isMountedRef.current) {
      setData(activityList)
      clearBusy()
    }
    return activityList
  }

  // const handleStatusFilterChange = () => {
  //   if (getState()?.selectedData.length !== 0) {
  //     history.push(`${routePaths.myJobs}`)
  //     setState({ selectedData: [] })  
  //   }
  // }

  const getPageData = async (page, pageSize) => {
    if (!isMountedRef.current) return []
    
    try {
      const data = await dataRet(value)
      return data
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching page data:', error)
      if (isMountedRef.current) {
        clearBusy()
      }
      return []
    }
  }

  const handleImageClick = async (imgReference) => {
    if (!isMountedRef.current) return
    
    setLoadingImage(false)
    setImageError(false)
    setSelectedRefImage(null)
    
    if (!imgReference) {
      if (isMountedRef.current) {
        setImageError(true)
        setLoadingImage(false)
        setSelectedRefImage(null)
      }
      return
    }
    
    const imageRef = Array.isArray(imgReference) ? imgReference[0] : imgReference
    
    if (!imageRef || imageRef === '' || imageRef === '-') {
      if (isMountedRef.current) {
        setImageError(true)
        setLoadingImage(false)
        setSelectedRefImage(null)
      }
      return
    }
    
    // --- OLD CODE (Commented out) ---
    // if (imageCache.current.has(imageRef)) {
    //   const cachedImage = imageCache.current.get(imageRef)
    //   if (cachedImage && isMountedRef.current) {
    //     isDialogOpenRef.current = true
    //     setSelectedRefImage(cachedImage)
    //     setLoadingImage(false)
    //     setImageError(false)
    //     return
    //   }
    // }
    
    if (!isMountedRef.current) return
    
    isDialogOpenRef.current = true // Mark dialog as open
    setLoadingImage(true)
    setSelectedRefImage(null) 
    setImageError(false)
    
    try {
      // The hook now handles the caching internally
      const imageUrl = await loadImageFromNats(imageRef)
      // Only update state if component is still mounted and dialog is still open
      if (isMountedRef.current && isDialogOpenRef.current) {
        if (imageUrl) {
          setSelectedRefImage(imageUrl) 
          setImageError(false)
        } else {
          setSelectedRefImage(null) 
          setImageError(true)
        }
      }
    } catch (error) {
      console.error('Error loading image:', error)
      if (isMountedRef.current && isDialogOpenRef.current) {
        setSelectedRefImage(null) 
        setImageError(true)
      }
    } finally {
      if (isMountedRef.current && isDialogOpenRef.current) {
        setLoadingImage(false)
      }
    }
  }
  
  const handleCloseImageDialog = () => {
    isDialogOpenRef.current = false // Mark dialog as closed
    setSelectedRefImage(null)
    setLoadingImage(false)
    setImageError(false)
  }

  const handleClose = () => {
    setSelectedRefImage(null)
    setLoadingImage(false)
    setImageError(false)
  }

  const loadImageFromNats = async (imgReference) => {
    if (!imgReference) return null
    
    // The hook handles checking the cache, fetching, saving to cache, and tracking for cleanup
    return await getImgFromNats(
      constants.LOCAL_NATS_SERVER,
      constants.LOCAL_AI_REF_IMG,
      imgReference,
      true // Enable caching
    )

    // --- OLD CODE (Commented out) ---
    // if (imageCache.current.has(imgReference)) {
    //   return imageCache.current.get(imgReference)
    // }
    // 
    // if (!imgReference.includes('nats')) {
    //   if (imgReference.startsWith('http://') || 
    //       imgReference.startsWith('https://') || 
    //       imgReference.startsWith('data:')) {
    //     imageCache.current.set(imgReference, imgReference)
    //     return imgReference
    //   }
    //   return null
    // }
    // 
    // if (imgReference.includes('nats')) {
    //   try {
    //     const imageUrl = await natsService.getImgFromNats(
    //       constants.LOCAL_NATS_SERVER, 
    //       constants.LOCAL_AI_REF_IMG, 
    //       imgReference
    //     )
    //     if (imageUrl) {
    //       imageCache.current.set(imgReference, imageUrl)
    //       return imageUrl
    //     }
    //   } catch (error) {
    //     console.error('Error loading image from NATS:', error)
    //     return null
    //   }
    // }
    // 
    // return null
  }

  const modifyOrderId = async(e, requestId) => {
    setState({
      showModalToModifyOrder: true,
      orderModifyRequesId: requestId,
    })
  }

  const handleOrderModifyModal = async() => {
    setState({
      showModalToModifyOrder: false,
      orderModifyRequesId: false,
    })
  }
  const handleCancelButtonOnClick = async (e, requestId) => {
    if (!isMountedRef.current) return
    
    try {   
      const collection = { status: 'cancelled', updatedTS: (new Date()).toISOString() }
      await localGdeTransactions.updateRequestData(requestId.rowActivityId, collection)
      
      if (isMountedRef.current) {
        closeGeneralDialog()
        handleClose()
        successToast({
          message: `${requestId.rowActivityId} ${t('smartCatalog.requestCancelSuccess')}`,
          title: t('toast.success'),
          autoHideDuration: 3000,
          isBlocking: false
        })
      }
    } catch (error) {
      // eslint-disable-next-line
      console.error('Error updating request data:', error)
    }
  }
  const ButtonsForCancelDialogBox = (rowActivityId) =>
    <>
      <OutlinedButton id={'boxList_dialogBoxButton_no'} onClick={closeGeneralDialog} >buttons.no</OutlinedButton>
      <ContainedButton id={'boxList_dialogBoxButton_yes'} onClick={(e) => handleCancelButtonOnClick(e, rowActivityId)}>{t('buttons.Ok')}</ContainedButton>
    </>
  const onSelect = (value, rowActivityId) => {
    if (value === 'pending') {
      openGeneralDialog({
        title: t('options.cancelRequestTitle'),
        message: `${t('options.cancelConfirmMessage')} ${rowActivityId}`,
        noTranslateTitle: true,
        buttons: <ButtonsForCancelDialogBox rowActivityId={rowActivityId}/>,
        closeX: true
      })
    }
  }

  const ImageContainer = () => {
    const isOpen = loadingImage || !!selectedRefImage || imageError
    
    if (!isOpen) return null
    
    return (
      <Dialog 
        open={isOpen}
        onClose={handleCloseImageDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent>
          <DialogContentText component="div">
            {loadingImage && !selectedRefImage && !imageError
              ? <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '400px',
                minWidth: '400px',
                gap: 2
              }}>
                <CircularProgress size={40} />
                <Typography variant="body2" color="textSecondary">
                  {t('Search.loading')}
                </Typography>
              </Box>
              : selectedRefImage && !imageError
                ? <img
                  src={selectedRefImage}
                  alt="Reference Image"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    display: 'block',
                    margin: '0 auto'
                  }}
                  onError={() => {
                    setSelectedRefImage(null) 
                    setLoadingImage(false)
                    setImageError(true)
                  }}
                />
                : <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: '400px',
                  minWidth: '400px',
                  gap: 2
                }}>
                  <Typography variant="body1" color="textSecondary" sx={{ textAlign: 'center' }}>
                    {t('smartCatalog.imageNotAvailable')}
                  </Typography>
                </Box>}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseImageDialog} color="primary">
            {t('dataEntry.close')}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
  
  const columns = [
    {
      accessorKey: 'activityId',
      header: t('tableColumns.requestId'),
      Cell: ({ cell }) => {
        const dataIndex = cell.row.index
        const rowdata = myJobdata[dataIndex]
        return (
          <JobLink
            id={`myJobs_jobLink_${rowdata.activityId}`}
            theme={theme}
            to={{
              pathname: `${routePaths.localactivityList}/${rowdata.activityId}`,
              state: {
                fromAdmin: false,
                rowData: rowdata
              }
            }}
          >
            {rowdata.activityId}
          </JobLink>
        )
      },
    },
    {
      accessorKey: 'customRequestName',
      header: t('tableColumns.customRequestName'),
      filterFn: 'includesString',
    },
    {
      accessorKey: 'status',
      header: t('tableColumns.status'),
    },
    {

      accessorKey: 'customer',
      header: 'Customer',
    },
    {
      accessorKey: 'confidence',
      header: t('templates.QCBypassThreshold').slice(0, -1)
    },
    {
      accessorKey: 'assetType',
      header: 'Asset Type',
    },
    {
      accessorKey: 'lob',
      header: t('tableColumns.lob'),

    },
    {
      accessorKey: 'dateCreated',
      header: t('tableColumns.dateCreated'),
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue || filterValue.length === 0) {
          return true
        }

        const filterMonth = new Date(filterValue[0])
        const rowDate = new Date(row.getValue(columnId)) 

        // Check if the row's date matches the selected month
        return rowDate.getFullYear() === filterMonth.getFullYear() &&
          rowDate.getMonth() === filterMonth.getMonth()
      },
      Filter: ({ column }) => {
        const { getFilterValue, setFilterValue } = column

        return (
          <DateTime
            label={t('tableColumns.dateCreated')}
            type='month'
            minDate={getMonth('2020-01')}
            maxDate={getMonth(today())}
            value={getFilterValue() ? getFilterValue()[0] : null}
            onChange={(selectedMonth) => {
              setFilterValue(selectedMonth ? [selectedMonth] : undefined)
            }}
          />
        )
      },
    },
    {
      header: t('tableColumns.boxes'),
      accessorKey: 'totalBoxes',
      Cell: ({ row }) => {
        const rowdata = row.original
        const totBoxCount = rowdata?.totalBoxes
        const error = rowdata?.error

        let textColor = 'black'
        let allowOrderModification = false
        if (error) {
          textColor = 'red'
          allowOrderModification = true
        }

        return (
          <span
            style={{ color: textColor, cursor: allowOrderModification ? 'pointer' : 'default' }}
            onClick={(e) => allowOrderModification && modifyOrderId(e, rowdata?.activityId)}
          >
            {totBoxCount}
          </span>
        )
      },
    },
    {
      accessorKey: 'orderNumber',
      header: 'Order Number',
    },
    {
      header: t('tableColumns.remarks'),
      accessorKey: 'remarks',
    },
    {
      header: t('tableColumns.imgReference'),
      accessorKey: 'imgReference',
      Cell: ({ row }) => {
        const refImage = row?.original?.imgReference
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              '&:hover': {
                opacity: 0.7
              }
            }}
            onClick={() => handleImageClick(refImage)}
          >
            <Visibility 
              style={{ 
                cursor: 'pointer', 
                fontSize: 32,
              }} 
            />
          </Box>
        )
      }
    },
    {
      header: t('tableColumns.action'),
      accessorKey: 'modify',
      enableColumnFilter: false,
      Cell: ({ row }) => {
        const rowData = row.original
        const pendingStatus = rowData?.status
        const rowActivityId = rowData?.activityId
  
        if (pendingStatus?.includes('pending')) {
          return (
            <MenuButton
              id="allJobs_ellipsis"
              buttonIcon={<MoreVert />}
              rowdata={rowData}
              items={menuItems}
              onSelect={(value) => onSelect(value, rowActivityId)}
            />
          )
        }
        return null 
      },
    },
  ]
  const options = {
    filterType: 'dropdown',
    enableSelectAll: false,
    enableRowSelection: false,
    enableSorting: true,
  }
  const menuItems = [
    { value: 'pending', id: 'cancel_request', label: t('tableColumns.cancelRequest'), style: { color: theme.palette.primary.main } },
  ]

  return (
    <>
      <TableContainer>
        <Box boxShadow={2} borderRadius={4}>
          <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '22px' }}>
            <Typography variant="h6" gutterBottom style={{ marginTop: '15px', color: '#58595B' }}>
              {t('smartCatalog.viewActivityData')}
            </Typography></div>
          <MaterialReactTable
            columns={columns}
            options={options}
            muiTableHeadCellProps={{
              sx: {
                color: '#58595B',
                fontWeight: 'bold',
              },
            }}
            prop={props}
            data={myJobdata}
            enableRowSelection
            enableExport={true}
            enableGlobalFilter
            enableColumnFilter
            enableColumnSorting
            enableGrouping={true}
            enableColumnResizing={true}
            initialState={{
              sorting: [
                {
                  id: 'dateCreated',
                  desc: true,
                },
              ],
              columnVisibility: { imgReference: true, modify: true },
              density: 'compact'
            }}
            renderTopToolbarCustomActions={({ table }) => {
              const isDisabled = !table.getIsSomeRowsSelected()
              const isNoData = myJobdata?.length === 0
              const isNoPageData = myJobdata?.length > 4
              return (
                // 1087: written a common component ExportCsv for making things easy 
                <ExportCsv
                  columns={columns}
                  isDisabled={isDisabled}
                  isNoData={isNoData}
                  isNoPageData={isNoPageData}
                  table={table}
                />
              )
            }}
            tableFor={'smart_catalog_view_requests'}
          />
        </Box>
        <ImageContainer/>
      </TableContainer>
      {getState()?.showModalToModifyOrder 
        ? (<LocalOrderModifyModal
            showModal={getState()?.showModalToModifyOrder}
            requestId={getState()?.orderModifyRequesId}
            handleShowModal={handleOrderModifyModal}
          />) 
        : null}
    </>
  )
}
LocalViewActivityData.propTypes = {
  FilterData: PropTypes.object,
  // DataSearch: PropTypes.string,
}

export default LocalViewActivityData